// The Heroku server endpoint.
export const API_SERVER = 'https://metalsco-api.herokuapp.com';
// export const API_SERVER = 'http://127.0.0.1:5000';

// The Mapbox access key
export const MAPBOX_ACCESS_KEY = 'pk.eyJ1Ijoicm9iZXJ0bmdvMjA3IiwiYSI6ImNrcDV5dm1hZjAydHcyd3FlNHU3NWR2eWQifQ.8_oVCEyyv1L0EdxeLoIKbA';
